import Loader from './Loader';
import './Loader.css';

export default function ExportLoadingOverlay() {
  return (
    <div className="export-loading-overlay" role="alert" aria-busy="true" aria-live="polite">
      <Loader size="lg" label="Exporting Excel…" />
    </div>
  );
}
